import script from "./loggedin-user-nav-dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./loggedin-user-nav-dropdown.vue?vue&type=script&setup=true&lang=js"

import "./loggedin-user-nav-dropdown.vue?vue&type=style&index=0&id=1d77b04d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d77b04d"]])

export default __exports__